module.exports = __webpack_public_path__ + "static/images/general/trash_bin_active.svg";